import React from 'react';
export function Footer() {
  return <footer className="py-8 bg-slate-950 border-t border-slate-900 text-center" data-id="element-45">
      <div className="container mx-auto px-4" data-id="element-46">
        <p className="text-slate-500 text-sm mb-4" data-id="element-47">
          © {new Date().getFullYear()} Dólares con IA. Todos los derechos
          reservados.
        </p>
        <p className="text-slate-600 text-xs max-w-2xl mx-auto" data-id="element-48">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc. Los resultados
          mostrados no son típicos y dependerán del esfuerzo y dedicación de
          cada persona.
        </p>
      </div>
    </footer>;
}